import {
  ColumnsModel,
  QueryBuilderComponent,
} from "@syncfusion/ej2-react-querybuilder";
import { StringColumn } from "./StringColumn";
import { NumberColumn } from "./NumberColumn";
import { BooleanColumn } from "./BooleanColumn";
import { DateColumn } from "./DateColumn";

export const equalOperator = { key: "Equal", value: "equal" };
export const notEqualOperator = { key: "Not Equal", value: "notequal" };
export const isNullOperator = { key: "Is Null", value: "isnull" };
export const isNotNullOperator = { key: "Is Not Null", value: "isnotnull" };
export const greaterOperator = { key: "Greater Than", value: "greaterthan" };
export const greaterOrEqualOperator = {
  key: "Greater Than or Equal",
  value: "greaterthanorequal",
};
export const lessOperator = { key: "Less Than", value: "lessthan" };
export const lessOrEqualOperator = {
  key: "Less Than or Equal",
  value: "lessthanorequal",
};
export const inOperator = { key: "In", value: "in" };
export const notInOperator = { key: "Not In", value: "notin" };
export const isEmptyOperator = { key: "Is Empty", value: "isempty" };
export const isNotEmptyOperator = { key: "Is Not Empty", value: "isnotempty" };

export const getColumnConfiguration = (
  column: ColumnsModel,
  queryBuilderRef: React.RefObject<QueryBuilderComponent | null>
) => {
  switch (column.type) {
    case "string":
      column = new StringColumn(column).ToColumn();
      break;
    case "number":
      column = new NumberColumn(column).ToColumn();
      break;
    case "boolean":
      column = new BooleanColumn(column).ToColumn();
      break;
    case "date":
      column = new DateColumn(column, queryBuilderRef).ToColumn();
      break;
  }

  return column;
};
